/* BatteryMate model finder — theme asset (bm-finder.js). Loaded by snippets/bm-finder-form.liquid (header) and usable by any input marked data-bm-finder.
   Talks to Shopify's built-in predictive search (/search/suggest.json), then groups results
   by what the product IS (battery, charger, remote, filter…) so the part the customer is
   actually looking for comes first. No app, no extra data, works with the existing catalogue.
   Config via window.BM_FINDER = { endpoint: '' (same origin) | 'https://proxy…', input: '#finder' } */
/* Speed apps may re-inject this script without `defer`, so wait for the DOM ourselves. */
(function () {
  function bmInit() {
  var cfg = Object.assign({ endpoint: '', input: '[data-bm-finder]', limit: 10, storeUrl: '', mode: 'inline', panelAfter: '' }, window.BM_FINDER || {});
  var input = document.querySelector(cfg.input);
  if (!input) return;
  var form = input.closest('form');
  var panel = document.createElement('div');
  panel.className = 'bmf';
  panel.setAttribute('role', 'region');
  panel.setAttribute('aria-live', 'polite');
  panel.hidden = true;
  var anchor = (cfg.panelAfter && document.querySelector(cfg.panelAfter)) || form || input.parentNode;
  anchor.insertAdjacentElement('afterend', panel);
  var wrap = input.closest('[data-bm-hf]');
  var hints = wrap && wrap.querySelector('[data-bm-hf-hints]');
  var clearBtn = wrap && wrap.querySelector('[data-bm-hf-clear]');
  function setOpen(on) { if (wrap) wrap.classList.toggle('bm-hf--open', !!on); }
  function showHints(on) { if (hints) { hints.hidden = !on; setOpen(on || !panel.hidden); } }
  function hidePanel() { panel.hidden = true; showHints(false); setOpen(false); }
  function syncClear() { if (clearBtn) clearBtn.hidden = !input.value.length; }

  /* ---- what is this product? order = what a model search should show first ---- */
  var ROLES = [
    ['accessory', /holder|shelf|rack|storage|converter|adapter|adaptor|tester|monitor|mount|stand|cable|strap|bag|head|brush|tool|nozzle|hose|attachment/i, 'Accessories'],
    ['charger', /charger|power supply|charging dock|docking/i, 'Chargers'],
    ['filter', /filter|hepa/i, 'Filters'],
    ['remote', /remote|key ?fob|\bkey\b|transmitter|controller/i, 'Remotes'],
    ['ink', /\bink\b|cartridge|toner/i, 'Ink and toner'],
    ['screen', /\blcd\b|screen|digiti[sz]er|display|glass/i, 'Screens'],
    ['case', /\bcase\b|cover|wallet|pouch|skin/i, 'Cases'],
    ['battery', /battery|batteries|\bcell\b|power ?pack|\bakku\b/i, 'Batteries']
  ];
  // what should lead when several kinds of part match the same model
  var LEAD = ['battery', 'remote', 'ink', 'charger', 'filter', 'screen', 'case', 'accessory', 'other'];
  function role(p) {
    var hay = (p.type || '') + ' ' + p.title;
    var t = p.type || '';
    if (/holder|shelf|rack|storage|converter|tester|monitor|mount|stand\b/i.test(hay)) return ROLES[0];
    for (var i = 0; i < ROLES.length; i++) if (ROLES[i][1].test(t)) return ROLES[i];
    for (i = 0; i < ROLES.length; i++) if (ROLES[i][1].test(hay)) return ROLES[i];
    return ['other', null, 'Other parts'];
  }

  /* ---- query normalisation: EN-2B27 / EN 2B27 / en2b27 should all find the same thing ---- */
  function variants(q) {
    q = q.trim().replace(/\s+/g, ' ');
    var out = [q];
    var tight = q.replace(/[-\s]+/g, '');
    if (tight !== q && tight.length >= 3) out.push(tight);
    var nohyphen = q.replace(/-/g, ' ');
    if (nohyphen !== q) out.push(nohyphen);
    // "bpl 3640d" -> "bpl3640d" (letters followed by digits, common way people type codes)
    var joined = q.replace(/\b([a-z]{1,4}) (\d{2,})/gi, '$1$2');
    if (joined !== q) out.push(joined);
    return out.filter(function (v, i, a) { return a.indexOf(v) === i; }).slice(0, 3);
  }
  function tokens(q) {
    var t = q.toLowerCase().split(/\s+/).map(function (x) { return x.replace(/-/g, ''); }).filter(function (x) { return x.length > 1; });
    var tight = q.toLowerCase().replace(/[-\s]+/g, '');
    if (t.length > 1 && tight.length >= 4) t.push(tight); // "bpl 3640" -> bpl3640 counts as a strong hit
    return t;
  }

  function fetchOne(q) {
    var u = cfg.endpoint + '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + cfg.limit +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,body,tag,variants.sku';
    return fetch(u, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { resources: { results: { products: [] } } }; })
      .then(function (j) { return (j.resources && j.resources.results && j.resources.results.products) || []; })
      .catch(function () { return []; });
  }

  function score(p, q) {
    var toks = tokens(q), title = p.title.toLowerCase().replace(/[-\s]/g, ''), tags = (p.tags || []).join(' ').toLowerCase().replace(/[-\s]/g, '');
    var body = (p.body || '').toLowerCase().replace(/<[^>]+>/g, ' ').replace(/[-\s]/g, '');
    var s = 0;
    toks.forEach(function (t) {
      if (title.indexOf(t) > -1) s += 3;
      else if (tags.indexOf(t) > -1) s += 2;
      else if (body.indexOf(t) > -1) s += 1;
    });
    if (!p.available) s -= 1;
    return s;
  }

  function money(v) { return (cfg.currency || '$') + Number(v).toFixed(2).replace(/\.00$/, ''); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(p) {
    var u = (p.featured_image && p.featured_image.url) || p.image || '';
    return u ? u.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
  }
  function card(p) {
    var url = cfg.storeUrl + p.url.split('?')[0];
    var was = p.compare_at_price_min && Number(p.compare_at_price_min) > Number(p.price_min);
    return '<a class="bmf__card" href="' + esc(url) + '">' +
      (img(p) ? '<img decoding="async" src="' + esc(img(p)) + '" alt="">' : '<span class="bmf__noimg"></span>') +
      '<span class="bmf__meta"><span class="bmf__title">' + esc(p.title) + '</span>' +
      '<span class="bmf__price">' + money(p.price_min) + (was ? ' <s>' + money(p.compare_at_price_min) + '</s>' : '') +
      (p.available ? '' : ' <em>Sold out</em>') + '</span></span></a>';
  }

  var seq = 0, timer, lastQ = '';
  function run(q) {
    var my = ++seq;
    panel.hidden = false; showHints(false); setOpen(true);
    panel.innerHTML = '<div class="bmf__state">Searching for “' + esc(q) + '”…</div>';
    Promise.all(variants(q).map(fetchOne)).then(function (lists) {
      if (my !== seq) return;
      var seen = {}, all = [];
      lists.forEach(function (l) { l.forEach(function (p) { if (!seen[p.handle]) { seen[p.handle] = 1; all.push(p); } }); });
      if (!all.length) {
        panel.innerHTML = '<div class="bmf__state">No match for “' + esc(q) + '” yet. Try the model number printed on the battery or device label, or ' +
          '<a href="' + cfg.storeUrl + '/search?q=' + encodeURIComponent(q) + '">search the whole store</a>.</div>';
        return;
      }
      all.forEach(function (p) { p._role = role(p); p._score = score(p, q); });
      var top = Math.max.apply(null, all.map(function (p) { return p._score; }));
      if (top >= 3) all = all.filter(function (p) { return p._score >= Math.max(1, top - 4); }); // drop loose matches once we have real ones
      all.sort(function (a, b) { return b._score - a._score || LEAD.indexOf(a._role[0]) - LEAD.indexOf(b._role[0]); });
      var floor = Math.max(1, top - 2), leadRole = all[0]._role[0];
      LEAD.some(function (r) { return all.some(function (p) { return p._role[0] === r && p._score >= floor; }) && (leadRole = r); });
      var lead = all.filter(function (p) { return p._role[0] === leadRole; })[0]._role, best = all.filter(function (p) { return p._role[0] === lead[0]; }), rest = all.filter(function (p) { return p._role[0] !== lead[0]; });
      var html = '<div class="bmf__group"><h4>' + esc(lead[2]) + ' for “' + esc(q) + '”</h4><div class="bmf__grid">' + best.slice(0, 4).map(card).join('') + '</div></div>';
      if (rest.length) {
        html += '<div class="bmf__group bmf__group--alt"><h4>Also for this model</h4><div class="bmf__grid">' + rest.slice(0, 4).map(card).join('') + '</div></div>';
      }
      html += '<div class="bmf__foot"><a href="' + cfg.storeUrl + '/search?q=' + encodeURIComponent(q) + '">See all ' + all.length + (all.length >= cfg.limit ? '+' : '') + ' results</a><span>Fit shown as listed on each product. Not right? 30-day money-back.</span></div>';
      panel.innerHTML = html;
    });
  }

  function onInput() {
    var q = input.value.trim();
    clearTimeout(timer);
    syncClear();
    if (q.length < 2) { panel.hidden = true; lastQ = ''; showHints(document.activeElement === input); return; }
    if (q === lastQ) return;
    timer = setTimeout(function () { lastQ = q; run(q); }, 260);
  }
  input.addEventListener('input', onInput);
  // if the script was delayed until the first keystroke, catch up with what is already typed
  // only auto-open if the shopper is already in the box (e.g. typed before the script loaded) — not on a pre-filled search page
  if (input.value.trim().length >= 2 && document.activeElement === input) onInput();
  if (form && cfg.mode !== 'header') form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); var q = input.value.trim(); if (q.length >= 2) { lastQ = q; run(q); } });
  // header mode: focus shows popular searches; clicking outside closes everything
  input.addEventListener('focus', function () { syncClear(); if (input.value.trim().length < 2) showHints(true); else if (lastQ) { panel.hidden = false; setOpen(true); } });
  document.addEventListener('click', function (e) { if (wrap && !wrap.contains(e.target) && !panel.contains(e.target)) hidePanel(); });
  if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; lastQ = ''; syncClear(); panel.hidden = true; input.focus(); showHints(true); });
  syncClear();
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hidePanel(); input.blur(); } });
  // quick links (data-bmf-q="Dyson V8") anywhere on the page
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-bmf-q]'); if (!a) return;
    e.preventDefault(); input.value = a.getAttribute('data-bmf-q'); input.focus(); lastQ = input.value; run(input.value);
  });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bmInit); else bmInit();
})();
